module.exports = __webpack_public_path__ + "img/36.2f2c3ff4.png";